// Route templates give reports a stable page dimension regardless of the entity
// being edited. Actual event and replay URLs are sanitized in privacy.ts.
const excludedPaths = ["/login", "/ai-discovery", "/inspiration"];

const staticPaths = new Set([
  "/",
  "/home",
  "/funnels",
  "/create/funnel",
  "/create/funnel/manual",
  "/experiments",
  "/experiments/create",
  "/smart-links",
  "/analytics",
  "/products",
  "/offers",
  "/media",
  "/customers",
  "/creators",
  "/template-library",
  "/ai",
  "/ad-accounts",
  "/strategy/roadmap",
  "/strategy/opportunities",
  "/settings",
  "/settings/billing",
  "/settings/brand",
  "/settings/storefront",
  "/settings/agent",
  "/settings/members",
  "/settings/notifications",
  "/settings/integrations",
  "/settings/custom-scripts",
  "/settings/global-css",
  "/onboarding",
  "/about",
  "/connect-shop",
  "/wait-for-demo",
  "/pick-demo-date",
  "/book-demo",
  "/demo-finalizing",
  "/otp-trust",
  "/admin",
  "/shop-not-active",
  "/shop-not-connected",
  "/invitation-failure",
  "/invitation-email-mismatch",
  "/slack/workspace",
  "/slack/connect",
  "/slack/install",
  "/slack/install/complete",
  "/oauth/authorize",
]);

const dynamicPaths = [
  { pattern: /^\/editor\/[^/]+$/, template: "/editor/[funnel]" },
  // Before the [id] patterns: "create" is not a buy box id.
  {
    pattern: /^\/studio\/buy-boxes\/create$/,
    template: "/studio/buy-boxes/create",
  },
  { pattern: /^\/studio\/pages\/[^/]+$/, template: "/studio/pages/[id]" },
  {
    pattern: /^\/studio\/global-sections\/[^/]+$/,
    template: "/studio/global-sections/[id]",
  },
  {
    pattern: /^\/studio\/buy-boxes\/[^/]+$/,
    template: "/studio/buy-boxes/[id]",
  },
  { pattern: /^\/review\/[^/]+$/, template: "/review/[token]" },
  { pattern: /^\/ai\/[^/]+$/, template: "/ai/[threadId]" },
  { pattern: /^\/experiments\/[^/]+$/, template: "/experiments/[id]" },
  {
    pattern: /^\/experiments\/[^/]+\/edit$/,
    template: "/experiments/[id]/edit",
  },
];

export function getAnalyticsPage(pathname: string) {
  const path = pathname.split(/[?#]/)[0]?.replace(/\/$/, "") || "/";
  if (
    excludedPaths.some(
      (excludedPath) =>
        path === excludedPath || path.startsWith(`${excludedPath}/`),
    )
  ) {
    return null;
  }
  let template = staticPaths.has(path) ? path : undefined;
  if (!template) {
    template = dynamicPaths.find(({ pattern }) => pattern.test(path))?.template;
  }
  if (!template) {
    const funnel = path.match(
      /^\/funnels\/[^/]+(?:\/(overview|media|orders|funnel-ads|smart-links|products))?$/,
    );
    const ads = path.match(
      /^\/ad-accounts\/[^/]+(?:\/(ads|campaigns|ad-sets))?$/,
    );
    if (funnel) template = `/funnels/[id]${funnel[1] ? `/${funnel[1]}` : ""}`;
    if (ads) template = `/ad-accounts/[adAccount]${ads[1] ? `/${ads[1]}` : ""}`;
  }
  const pagePath = template ?? "/unknown";
  return {
    page_path: pagePath,
    page_section: pagePath.split("/")[1] || "home",
  };
}
